import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { RmsContractBalance } from '@cemex-core/cmx-api';
import * as fromProductsOpenPlatformActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/products.op.actions';

export interface State extends EntityState<RmsContractBalance> {
  selectedContractBalanceId: number | null;
}

export const adapter: EntityAdapter<RmsContractBalance> = createEntityAdapter<RmsContractBalance>({
  selectId: (_contractBalance: RmsContractBalance) => _contractBalance.agreementId,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedContractBalanceId: null,
});

export function reducer(state = initialState, action: fromProductsOpenPlatformActions.Actions): State {
  switch (action.type) {
    case fromProductsOpenPlatformActions.ActionTypes.FETCH_CONTRACT_BALANCE_SUCCESS: {
      return adapter.addMany(action.payload, state);
    }
    case fromProductsOpenPlatformActions.ActionTypes.RESET: {
      return adapter.removeAll(state);
    }
    case fromProductsOpenPlatformActions.ActionTypes.FETCH_CONTRACT_BALANCE:
    default:
      return state;
  }
}
